import IMG1 from '../../assets/jointAccount.png';
import IMG2 from '../../assets/lottery.jpeg';
import IMG3 from "../../assets/topic_modeling.png";
import IMG4 from "../../assets/grammar.png";
import IMG5 from "../../assets/shop.png";
import IMG6 from "../../assets/puzzle.jpg";
import IMG7 from '../../assets/sorting_algorithms_visualizer.png'

export const projects_list = [
  {
    id: 1,
    image: IMG1,
    title: "Full Stack Web3 Joint Account DApp",
    language: "Solidity, React.js, Ethereum, Ethers.js, Hardhat, Ganache",
    github: "https://github.com/The-Indian-Programmer",
    demo: "https://github.com/The-Indian-Programmer",
  },
  {
    id: 2,
    image: IMG2,
    title: "Lottery DApp With Chainlink VRF",
    language: "Solidity, React.js, Ethereum, Ethers.js, Hardhat, Ganache",
    github: "https://github.com/The-Indian-Programmer/Blockchain-Freecodecamp/tree/master/hardhat-lottery",
    demo: "https://web3-lottery.netlify.app/",
  },
];